import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

const Style = styled.nav.attrs((props) => ({
  className: "nav",
}))``

const Menu = styled.ul.attrs((props) => ({
  className: "nav__menu",
}))`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  font-size: 1em;
  flex-direction: column;

  ${breakpoint("md")`
        flex-direction: row;
        align-items: center;
        justify-content: center;
    `}

  > li {
    min-height: 100%;
    display: block;
    margin-bottom: 0;

    ${breakpoint("md")`
            margin-right: .75em;
        `}

    + li {
      margin-top: 1em;
      position: relative;

      ${breakpoint("md")`
                margin-top: 0;
                padding-left: .75em;

                &::before {
                    content:'';
                    width:1px;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    background-color: ${(props) => props.theme.colors.primaryDark};
                }
            `}
    }
  }

  .nav__link {
    font-weight: 500;
    cursor: pointer;
    color: ${(props) => props.theme.colors.textColor};
    text-decoration: none;
    height: 100%;
    display: inline-block;
    position: relative;
    outline: none;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      background-color: ${(props) => props.theme.colors.textColor};
      height: 1px;
      transform: translateY(0.25em);
      transition: width 0.2s ease;
    }

    &:hover::after,
    &:focus::after,
    &.is-active::after {
      width: 100%;
    }
  }
`

/**
 * @visibleName Navigation
 */
const Navigation = ({ linkElement, remove, tree }) => {
  const Elem = linkElement

  return (
    <Style>
      <Menu>
        {tree.map((item, i) => (
          <li key={i}>
            <Elem
              className="nav__link"
              activeClassName="is-active"
              to={item.link.url.replace(remove, "")}
            >
              {item.link.title}
            </Elem>
          </li>
        ))}
      </Menu>
    </Style>
  )
}

export default Navigation

Navigation.propTypes = {
  tree: PropTypes.array,
}
Navigation.defaultProps = {
  linkElement: React.createElement("span"),
}
